const { Splide } = require("@splidejs/splide");


require("fslightbox");


const various = {
    env: "preprod",
    init() {

        if (document.querySelector('#filter_by_year')) {
            console.log(document.querySelector('#filter_by_year select'));
            document.querySelector('#filter_by_year select').addEventListener('input', () => {
                document.querySelector('#filter_by_year form').submit();
            })

        }
        
    },
};

module.exports = various;
